<template>
    <v-card
        class="mx-auto"
        elevation="1"
        :loading="loading"
    >
        <v-list-item>
            <v-list-item-avatar color="red" class="headline white--text">{{ count }}</v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="headline">{{ caption }}</v-list-item-title>
                <v-list-item-subtitle>{{ subtitle }}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
    </v-card>
</template>

<script>
    export default {
        name: "bricks_small",

        props: {
            caption : null,
            subtitle : null,
            count : null,
            loading: true
        },

        data: () => ({

        })
    }
</script>

<style scoped>

</style>
